var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.896 4.75033L6.40641 3.26074C3.90641 5.16699 2.26058 8.10449 2.11475 11.4378H4.19808C4.35433 8.67741 5.771 6.26074 7.896 4.75033ZM20.8022 11.4378H22.8856C22.7293 8.10449 21.0835 5.16699 18.5939 3.26074L17.1147 4.75033C19.2189 6.26074 20.646 8.67741 20.8022 11.4378ZM18.7502 11.9587C18.7502 8.76074 17.0418 6.08366 14.0627 5.37533V4.66699C14.0627 3.80241 13.3647 3.10449 12.5002 3.10449C11.6356 3.10449 10.9377 3.80241 10.9377 4.66699V5.37533C7.94808 6.08366 6.25016 8.75033 6.25016 11.9587V17.167L4.16683 19.2503V20.292H20.8335V19.2503L18.7502 17.167V11.9587ZM12.5002 23.417C12.646 23.417 12.7814 23.4066 12.9168 23.3753C13.5939 23.2295 14.146 22.7712 14.4168 22.1462C14.521 21.8962 14.5731 21.6253 14.5731 21.3337H10.4064C10.4168 22.4795 11.3439 23.417 12.5002 23.417Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.dbbc9ed8be5105a3bdc83a53b1ff8963.svg";
export { ForwardRef as ReactComponent };